import { bffParceirosApiService } from '../../../../services/bff'

export class AuthorizationHelper {
  static isOperatorAllowedToUploadImage(): boolean {
    const role = bffParceirosApiService.auth.getUser()?.role
    return false
  }
}
